import { Check } from 'lucide-react'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label?: string
  disabled?: boolean
}

export function Checkbox({ checked, onChange, label, disabled = false }: CheckboxProps) {
  return (
    <label className="inline-flex items-center">
      <div
        className={`
          w-4 h-4 rounded border
          ${checked
            ? 'bg-blue-500 border-blue-500'
            : 'bg-white border-gray-300'
          }
          ${disabled
            ? 'opacity-50 cursor-not-allowed'
            : 'cursor-pointer hover:border-blue-500'
          }
        `}
        onClick={() => !disabled && onChange(!checked)}
      >
        {checked && (
          <Check className="w-3 h-3 text-white" />
        )}
      </div>
      {label && (
        <span className={`ml-2 text-sm ${disabled ? 'text-gray-400' : 'text-gray-700'}`}>
          {label}
        </span>
      )}
    </label>
  )
} 